import React, { Component } from 'react';

export default class CastDone extends Component {
  constructor (props) {
    super(props);

    this.state = {
    };
  }

  componentWillMount () {

  }

  send(password) {
    window.location.href = 'https://30min.page/';
  }

  render () {
    return (
   	<div className="sp home">
      <h2>登録完了</h2>
      <div className="content-wrapper">
        <div className="contents">

          <p className="bold">登録が完了いたしました！</p>
          <br />
          

          <div className="buttons">
            <button onClick={this.send.bind(this)}>トップへ</button>
          </div>
        </div>
      </div>
    </div>
    );
  }
}